function getTruncatedText(text: string, length: number = 100): string {
  if (text.length > length) {
    return `${text.substring(0, length)}...`;
  }

  return text;
}

export default getTruncatedText;
